<!-- tire-assignment.component.html -->
<div class="tire-assignment-container">
  <div class="header">
    <h1>Position Component</h1>
    
    <!-- Truck Type Selector (Dynamic Config) -->
    <div class="truck-selector">
      <label>Truck Configuration:</label>
      <select [(ngModel)]="selectedConfig" (ngModelChange)="onConfigChange()">
        <option value="4x2">4x2</option>
        <option value="6x4">6x4</option>
        <option value="8x4" selected>8x4</option>
        <option value="10x2">10x2</option>
      </select>
    </div>
  </div>

  <div class="main-content">
    <!-- LEFT SIDE: Truck Positions (Dynamic based on config) -->
    <div class="truck-panel">
      <div class="truck-visual">
        <!-- Simple Truck SVG Background -->
        <svg width="100%" height="420" viewBox="0 0 800 420" fill="none" xmlns="http://www.w3.org/2000/svg" class="truck-svg">
          <!-- Truck body -->
          <rect x="50" y="100" width="680" height="220" rx="20" fill="#e2e8f0" stroke="#1e2937" stroke-width="25"/>
          <!-- Cab -->
          <rect x="50" y="80" width="180" height="80" rx="15" fill="#1e2937"/>
          <!-- Windows -->
          <rect x="80" y="100" width="50" height="40" fill="#64748b"/>
          <!-- Wheels placeholders (will be replaced by dynamic positions) -->
          <circle cx="180" cy="340" r="45" fill="#cbd5e1"/>
          <circle cx="340" cy="340" r="45" fill="#cbd5e1"/>
          <circle cx="500" cy="340" r="45" fill="#cbd5e1"/>
          <circle cx="660" cy="340" r="45" fill="#cbd5e1"/>
        </svg>

        <!-- Dynamic Position Groups -->
        <div class="positions-overlay">
          <ng-container *ngFor="let group of groups()">
            <div class="group">
              <h3 class="group-header">{{ group.name }}</h3>
              <div class="group-positions" [class.two-col]="group.positions.length === 2">
                <div *ngFor="let posId of group.positions"
                     class="position-box"
                     [attr.data-position]="posId"
                     (dragover)="onDragOver($event)"
                     (drop)="onDrop($event, posId)"
                     (dragenter)="onDragEnter($event)"
                     (dragleave)="onDragLeave($event)">
                  
                  <!-- Assigned Tire -->
                  <ng-container *ngIf="getAssignedTire(posId) as tire; else emptySlot">
                    <div class="tire-wrapper"
                         draggable="true"
                         (dragstart)="onDragStart($event, tire.id, posId)">
                      <!-- Tire SVG -->
                      <svg width="72" height="72" viewBox="0 0 200 200" class="tire-svg" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="100" cy="100" r="78" fill="#1e2937" stroke="#f1f5f9" stroke-width="18"/>
                        <circle cx="100" cy="100" r="48" fill="#f8fafc"/>
                        <circle cx="100" cy="100" r="28" fill="#1e2937"/>
                        <!-- Tread lines -->
                        <g opacity="0.4">
                          <rect x="30" y="85" width="140" height="12" rx="2" fill="#f1f5f9"/>
                          <rect x="30" y="105" width="140" height="12" rx="2" fill="#f1f5f9"/>
                        </g>
                      </svg>
                      <div class="tire-label">
                        <span class="tire-name">{{ tire.name }}</span>
                        <span class="tire-type" [class.new]="tire.type === 'new'" [class.old]="tire.type === 'old'">
                          {{ tire.type === 'new' ? 'NEW' : 'OLD' }}
                        </span>
                      </div>
                    </div>
                  </ng-container>

                  <!-- Empty Slot -->
                  <ng-template #emptySlot>
                    <div class="empty-slot">
                      <svg width="72" height="72" viewBox="0 0 200 200" class="empty-tire-svg">
                        <circle cx="100" cy="100" r="78" fill="none" stroke="#cbd5e1" stroke-width="18" stroke-dasharray="8 8"/>
                        <circle cx="100" cy="100" r="48" fill="none" stroke="#cbd5e1" stroke-width="12"/>
                      </svg>
                      <span class="empty-text">Drop Tyre Here</span>
                    </div>
                  </ng-template>
                </div>
              </div>
            </div>
          </ng-container>
        </div>
      </div>
    </div>

    <!-- RIGHT SIDE: Tyre List -->
    <div class="tyre-panel">
      <h3 class="panel-title">Available Tyres</h3>
      
      <div class="tyre-list-container"
           (dragover)="onDragOver($event)"
           (drop)="onDrop($event, null)"
           (dragenter)="onDragEnter($event)"
           (dragleave)="onDragLeave($event)">
        
        <!-- New Tyres Section -->
        <div class="tyre-section">
          <h4 class="section-header new-header">New Tyres</h4>
          <div class="tyre-list">
            <div *ngFor="let tire of availableNewTires()"
                 class="tyre-item"
                 draggable="true"
                 (dragstart)="onDragStart($event, tire.id)">
              <div class="tyre-icon">
                <svg width="48" height="48" viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="100" cy="100" r="78" fill="#1e2937" stroke="#22c55e" stroke-width="18"/>
                  <circle cx="100" cy="100" r="48" fill="#f8fafc"/>
                  <circle cx="100" cy="100" r="28" fill="#1e2937"/>
                </svg>
              </div>
              <div class="tyre-info">
                <span class="tyre-name">{{ tire.name }}</span>
                <span class="tyre-badge new">NEW</span>
              </div>
            </div>
          </div>
        </div>

        <!-- Old Tyres Section -->
        <div class="tyre-section">
          <h4 class="section-header old-header">Old Tyres</h4>
          <div class="tyre-list">
            <div *ngFor="let tire of availableOldTires()"
                 class="tyre-item"
                 draggable="true"
                 (dragstart)="onDragStart($event, tire.id)">
              <div class="tyre-icon">
                <svg width="48" height="48" viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="100" cy="100" r="78" fill="#1e2937" stroke="#f59e0b" stroke-width="18"/>
                  <circle cx="100" cy="100" r="48" fill="#f8fafc"/>
                  <circle cx="100" cy="100" r="28" fill="#1e2937"/>
                </svg>
              </div>
              <div class="tyre-info">
                <span class="tyre-name">{{ tire.name }}</span>
                <span class="tyre-badge old">OLD</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Action Buttons -->
      <div class="actions">
        <button (click)="saveToBackend()" class="btn-primary">
          <span>Save Configuration to Backend</span>
        </button>
        <button (click)="resetAll()" class="btn-secondary">
          Reset All
        </button>
      </div>
    </div>
  </div>
</div>